import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.addEventListener("load", function () {
  var $carousel = document.querySelector("#frame2 .carousel");
  if (!$carousel) return;
  // PC hiện 5 thẻ (giữ |progress| ≤ 2), mobile hiện 3 thẻ (giữ |progress| ≤ 1).
  // Breakpoint khớp $maxWidthMB của project (768px).
  function hideEdgeSlides(sw) {
    var keepEachSide = window.matchMedia("(max-width: 768px)").matches ? 1 : 2;
    sw.slides.forEach(function (s) {
      s.style.visibility = Math.abs(s.progress) > keepEachSide + 0.5 ? "hidden" : "";
    });
  }

  // KHÔNG set loopedSlides — để Swiper 8 tự gán = slides.length rồi clone đủ vòng.
  var carousel = new Swiper($carousel, {
    effect: "coverflow",
    centeredSlides: true,
    slidesPerView: "auto",
    loop: true,
    watchSlidesProgress: true, // cần progress từng slide để lọc thẻ mép
    coverflowEffect: {
      rotate: 0,
      stretch: 250,
      depth: 100,
      modifier: 0.8,
      slideShadows: true,
    },
    navigation: {
      prevEl: "#frame2 .prev",
      nextEl: "#frame2 .next",
    },
    pagination: {
      el: "#frame2 .swiper-pagination",
      clickable: true,
    },
    on: {
      // setTranslate chạy liên tục cả khi kéo/chuyển → ẩn/hiện mượt theo vị trí
      init: hideEdgeSlides,
      setTranslate: hideEdgeSlides,
      setTransition: hideEdgeSlides,
    },
  });
});
